import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Branding/Logo';

function OnboardingAgentScreen() {
  return (
    <div className="col-md-6 form-side">
      <div className="form-container text-center">
        <Logo />
        <h1 className="text-success fw-bold mb-4">Portal para Asesores</h1>
        <h4 className="mb-5">Bienvenido, asesor. Accede a tus herramientas y gestiona clientes.</h4>
        <p>Inicia sesión para comenzar a utilizar la plataforma de asesoramiento de Checkin.</p>
        <div className="buttons-container d-grid gap-3 mt-5 mb-5">
          <Link to="/login" className="btn btn-checkin" role="button">
            Iniciar Sesión
          </Link>
        </div>
        <p className="mt-3 text-muted small">Plataforma Checkin © 2024</p>
      </div>
    </div>
  );
}
export default OnboardingAgentScreen;